// toast.tokens.ts
import { InjectionToken } from '@angular/core';
import { AriaToastrInformationService } from '@app/services/toastr/aria-toastr-information.service';

export const ARIA_TOAST_SERVICE = new InjectionToken<AriaToastrInformationService>('AriaToastrInformationService');